import BossHome from "../Routes/boss/page";
import BossLogin from "../Routes/boss/login/page";
import PasswordReset from "../Routes/boss/login/password-reset/page";

import OnboardingSalesOverview from "../Routes/boss/onboarding/sales-overview/page";
import OnboardingPreorderSales from "../Routes/boss/onboarding/preorder-sales/page";
import OnboardingLiveSales from "../Routes/boss/onboarding/live-sales/page";
import OnboardingComplete from "../Routes/boss/onboarding/complete/page";
import BossLikes from "../Routes/boss/likes/page";
import BossReport from "../Routes/boss/report/page";
import BossReview from "../Routes/boss/review/page";

import LiveOrderUpload from "../Routes/boss/live-order/upload/page";
import SelectFromMenu from "../Routes/boss/live-order/select-from-menu/page";
import ManualEntry from "../Routes/boss/live-order/manual-entry/page";
import MenuManagement from "../Routes/boss/live-order/menus/page";
import LiveOrderSales from "../Routes/boss/live-order/sales/page";
import SalesProductUpdate from "../Routes/boss/live-order/sales/sales-product-update/page";
import SalesManualUpdate from "../Routes/boss/live-order/sales/sales-manual-update/page";
import BossStorePreviewCard from "../Routes/boss/store-preview/card/page";
import BossStorePreviewDetail from "../Routes/boss/store-preview/detail/page";

import PreOrderHome from "../Routes/boss/pre-order/page";
import PreOrderPackManagement from "../Routes/boss/pre-order/pack-management/page";
import PickupTimeUpdate from "../Routes/boss/pre-order/pickup-time-update/page";
import PreOrderSales from "../Routes/boss/pre-order/sales/page";

import BossMy from "../Routes/boss/my/page";
import StoreManagement from "../Routes/boss/my/store-management/page";
import BossProfile from "../Routes/boss/my/profile/page";
import BossChangePassword from "../Routes/boss/my/profile/change-password/page";
import BossSupport from "../Routes/boss/my/support/page";
import MyRevenue from "../Routes/boss/my/revenue/page";
import Settlement from "../Routes/boss/my/banking/page";
import SettlementInfoUpdate from "../Routes/boss/my/banking/settlement-info-update/page";
import SettlementDetail from "../Routes/boss/my/banking/settlement-detail/page";
import SettlementPaid from "../Routes/boss/my/banking/settlement-paid/page";
import SettlementRequest from "../Routes/boss/my/banking/settlement-request/page";
import Notification from "../Routes/boss/my/notification/page";
import BossNotice from "../Routes/boss/my/notice/page";
import BossGuideHowToUse from "../Routes/boss/my/guide/how-to-use/page";
import BossSupportContactNumber from "../Routes/boss/my/support/contact-number/page";
import BlacklistPage from "../Routes/boss/my/blacklist/page";
import BossFeedback from "../Routes/boss/feedback/page";
import BossFeedbackDetail from "../Routes/boss/feedback/detail/page";
import SignupCheckStatus from "../Routes/boss/signup/check-status/page";
import SignupStoreCreation from "../Routes/boss/signup/store-creation/page";
import SignupPackManagement from "../Routes/boss/signup/pack-management/page";
import SignupServiceOverview from "../Routes/boss/signup/service-overview/page";
import SignupPickupTime from "../Routes/boss/signup/pickup-time/page";
import SignupAccountRegister from "../Routes/boss/signup/account-register/page";
import SignupComplete from "../Routes/boss/signup/complete/page";

import BossSignUp from "../Routes/boss/administrator/boss-signup";
import TossCardPreview from "../Routes/boss/dev/toss-card-preview/page";
import PreOrderFAQ from "../Routes/boss/pre-order/faq/page";
import LiveOrderFAQ from "../Routes/boss/live-order/faq/page";
import OnboardingPreorderShortcut from "../Routes/boss/onboarding/preorder-shortcut/page";
import OnboardingLiveOrderShortcut from "../Routes/boss/onboarding/live-order-shortcut/page";
import LiveOrderIntro from "../Routes/boss/live-order/intro/page";
import LiveOrderPreviousSales from "../Routes/boss/live-order/previous-sales/page";
import PreOrderPreviousSales from "../Routes/boss/pre-order/previous-sales/page";
import LiveOrderNotice from "../Routes/boss/live-order-notice/page";
import { useAuth } from "../core/auth";
import { Navigate } from "react-router-dom";
import BossApplicantOnboarding from "../Routes/boss/applicant/onboarding/page";

const BosssAuth = ({ children }: { children: JSX.Element }) => {
  const { isAdminLoggedIn } = useAuth();

  if (isAdminLoggedIn) {
    return children;
  }

  return <Navigate to="/boss/login" />;
};

// prettier-ignore
export const bossRoutes = [
  { path: "/boss/home", element: (
    <BosssAuth>
      <BossHome />
    </BosssAuth>
  ) },
  { path: "/boss/login", element: <BossLogin /> },
  { path: "/boss/login/password-reset", element: <PasswordReset /> },

  // (가입o) 온보딩
  { path: "/boss/onboarding/sales-overview", element: <OnboardingSalesOverview /> },
  { path: "/boss/onboarding/preorder-shortcut", element: <OnboardingPreorderShortcut /> },
  { path: "/boss/onboarding/preorder-sales", element: <OnboardingPreorderSales /> },
  { path: "/boss/onboarding/live-order-shortcut", element: <OnboardingLiveOrderShortcut /> },
  { path: "/boss/onboarding/live-sales", element: <OnboardingLiveSales /> },
  { path: "/boss/onboarding/complete", element: <OnboardingComplete /> },

  { path: "/boss/likes", element: <BossLikes /> },
  { path: "/boss/report", element: <BossReport /> },
  { path: "/boss/review", element: <BossReview /> },
  { path: "/boss/feedback", element: (
    <BosssAuth>
      <BossFeedback />
    </BosssAuth>
  ) },
  { path: "/boss/feedback/detail/:id", element: (
    <BosssAuth>
      <BossFeedbackDetail />
    </BosssAuth>
  ) },
  { path: "/boss/store-preview/card/:id", element: <BossStorePreviewCard /> },
  { path: "/boss/store-preview/detail/:id", element: <BossStorePreviewDetail /> },

  { path: "/boss/live-order/intro", element: <LiveOrderIntro /> },
  { path: "/boss/live-order/upload", element: <LiveOrderUpload /> },
  { path: "/boss/live-order/select-from-menu", element: <SelectFromMenu /> },
  { path: "/boss/live-order/manual-entry", element: <ManualEntry /> },
  { path: "/boss/live-order/sales", element: <LiveOrderSales /> },
  { path: "/boss/live-order/sales/product-update/:id", element: <SalesProductUpdate /> }, // 뜻이 컴포넌트의 본질을 대변하지 못하고 있음.
  { path: "/boss/live-order/sales/manual-update/:id", element: <SalesManualUpdate /> },
  { path: "/boss/live-order/menu-management", element: <MenuManagement /> },
  { path: "/boss/live-order/previous-sales", element: <LiveOrderPreviousSales /> },
  { path: "/boss/live-order-notice", element: <LiveOrderNotice /> },
  { path: "/boss/live-order/faq", element: <LiveOrderFAQ /> },

  { path: "/boss/pre-order/home", element: <PreOrderHome /> },
  { path: "/boss/pre-order/pack-management", element: <PreOrderPackManagement />, },
  { path: "/boss/pre-order/pickup-time-update", element: <PickupTimeUpdate /> },
  { path: "/boss/pre-order/sales", element: <PreOrderSales /> },
  { path: "/boss/pre-order/previous-sales", element: <PreOrderPreviousSales /> },
  { path: "/boss/pre-order/faq", element: <PreOrderFAQ /> },

  { path: "/boss/my", element: <BossMy /> },
  { path: "/boss/my/store-management", element: <StoreManagement /> },
  { path: "/boss/my/profile", element: <BossProfile /> },
  { path: "/boss/my/profile/change-password", element: <BossChangePassword /> },
  { path: "/boss/my/support", element: <BossSupport /> },
  { path: "/boss/my/support/contact-number", element: <BossSupportContactNumber /> },
  { path: "/boss/my/revenue", element: <MyRevenue /> },
  { path: "/boss/my/banking/settlement", element: <Settlement /> },
  { path: "/boss/my/banking/settlement-info-update", element: <SettlementInfoUpdate /> },
  { path: "/boss/my/banking/settlement-detail", element: <SettlementDetail /> },
  { path: "/boss/my/banking/settlement-paid", element: <SettlementPaid /> },
  { path: "/boss/my/banking/settlement-request", element: <SettlementRequest /> },
  { path: "/boss/my/notification", element: <Notification /> },
  { path: "/boss/my/notice", element: <BossNotice /> },
  { path: "/boss/my/guide/how-to-use", element: <BossGuideHowToUse /> },
  { path: "/boss/my/blacklist", element: <BlacklistPage /> },

  // 입점 신청 소개 온보딩 (가입 x)
  { path: "/boss/applicant/onboarding", element: <BossApplicantOnboarding /> },

  { path: "/boss/signup/register", element: <SignupAccountRegister /> },
  { path: "/boss/signup/store", element: <SignupStoreCreation /> },
  { path: "/boss/signup/reserve-pack/pack", element: <SignupPackManagement />, },
  { path: "/boss/signup/onboarding/reserve-pack", element: <SignupServiceOverview />, },
  { path: "/boss/signup/reserve-pack/pickup", element: <SignupPickupTime />, },
  { path: "/boss/signup/complete", element: <SignupComplete /> },
  { path: "/boss/signup/state", element: <SignupCheckStatus /> },

  { path: "/boss/sign-up", element: <BossSignUp /> },

  // DEV ONLY: UI 프리뷰 (배포 전 삭제)
  { path: "/boss/dev/toss-card-preview", element: <TossCardPreview /> },
];
